/* eslint-disable react-hooks/exhaustive-deps */
import Layout from "../../Components/Layout";
import { useNavigate, useParams } from "react-router";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Metatags } from "../../types";
import { BASE_API_URL } from "../../API/Base";
import AxiosInstance from "../../API/axios";
import { Button, Grid, TextField } from "@mui/material";
import toast from "react-hot-toast";

type Props = {};

const MetaEdit = (props: Props) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [metaData, setMetaData] = useState<Metatags>();
  const {
    handleSubmit,
    control,
    setValue,
    reset,

    formState: { errors },
  } = useForm<Metatags>();

  const base64Decode = (encodedStr: string) => {
    return atob(encodedStr);
  };
  const decodedId = id ? base64Decode(id) : null;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosInstance.get(
          `${BASE_API_URL}/admin/web-content/v1/get-metatag/${decodedId}`
        );
        const metatagsData: Metatags = response.data;
        setMetaData(metatagsData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [decodedId, setValue]);

  useEffect(() => {
    reset({
      meta_title: metaData?.meta_title,
      meta_description: metaData?.meta_description,
      meta_keywords: metaData?.meta_keywords,
      ref_id: metaData?.ref_id,
      page_type_id: metaData?.page_type_id,
    });
  }, [metaData]);

  const TextFieldStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    "& .MuiInputLabel-root": {
      color: "#000",
      "&.Mui-focused": {
        color: "#000",
      },
    },
    "& .MuiInputLabel-shrink": {
      color: "#00A99D",
    },
    "& .MuiOutlinedInput-root": {
      "& .MuiInputBase-input": {
        color: "#000",
        fontSize: "14px",
      },
      "& .MuiSelect-icon": {
        fill: "#000 !important",
      },
    },
  };

  const onSubmit = async (data: Metatags) => {
    try {
      const metdata = {
        meta_title: data.meta_title,
        meta_description: data.meta_description,
        meta_keywords: data.meta_keywords,
      };

      const response = await AxiosInstance.put(
        `${BASE_API_URL}/admin/web-content/v1/update-metadata/${decodedId}`,
        metdata
      );

      if (response.status === 200) {
        toast.success("Meta tags updated successfully");
      }
    } catch (error) {
      console.error("Error creating meta tags:", error);
    }
  };

  return (
    <Layout PageId={12}>
      <div className="flex flex-col items-start justify-start w-full h-full mt-4 rounded-md">
        <form className="flex flex-col items-start w-full justify-normal">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Controller
                name="meta_title"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    label="Title"
                    error={Boolean(errors.meta_title)}
                    className="w-full p-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-primary focus:ring-0"
                    {...field}
                    sx={TextFieldStyle}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <div className="relative">
                <Controller
                  name="meta_description"
                  control={control}
                  defaultValue=""
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div className="relative">
                      <TextField
                        type="text"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        label="Description"
                        error={Boolean(errors.meta_description)}
                        className="w-full p-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-primary focus:ring-0"
                        {...field}
                        sx={TextFieldStyle}
                      />
                    </div>
                  )}
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="meta_keywords"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    label="Keywords"
                    error={Boolean(errors.meta_keywords)}
                    className="w-full p-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-primary focus:ring-0"
                    {...field}
                    sx={TextFieldStyle}
                  />
                )}
              />
            </Grid>
          </Grid>
        </form>
        <div className="flex flex-row items-center justify-between w-full mt-4 mb-4">
          <Button
            variant="contained"
            color="primary"
            sx={{
              color: "#fff",
            }}
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </Button>

          <Button
            variant="outlined"
            onClick={() => navigate("/web/meta-tags/manage")}
            sx={{
              color: "#000",
              border: "1px solid #000",
            }}
          >
            Back
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default MetaEdit;
